export const getUserCommercialLicense = async () => {
  try {
    const request = await BX.ajax.runComponentAction(
      "license:last.list",
      "ShowLastLicensesForMainPage",
      {
        mode: "class",
        data: {},
      }
    );

    return {
      currentShown: request.data.data.length,
      licenses: request.data.data.slice(0, 5),
      total: request.data.recordsTotal,
    };
  } catch (error) {
    return {
      isError: true,
      message: error.errors ? error.errors[0].message : error,
    };
  }
};
